import { CourseState } from './types';

export const state = (): CourseState => initialState();

export const initialState = (): CourseState => ({
  courses: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [
        'Name',
        'locationNames',
        // 'trainerFullName',
        'description',
      ],
    },
  },
});
